// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-table-container {
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 64px;
  width: 100%;
}
.user-table-container .search-bar {
  display: flex;
  width: 35%;
}
.user-table-container .search-bar .filter-select {
  width: 200px;
  /* stylelint-disable-next-line selector-class-pattern */
}
.user-table-container .search-bar .filter-select .cec-select__control {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}
.user-table-container .search-bar .filter-input {
  border-bottom-left-radius: 0;
  border-left: 0;
  border-top-left-radius: 0;
}
.user-table-container .user-table {
  background-color: white;
  border-radius: 8px;
  padding: 8px;
  width: 65%;
}
.user-table-container .user-table .loading-icon {
  color: #127ec0;
  display: flex;
  height: 64.75px;
  justify-content: center;
  width: 100%;
}
.user-table-container .edit-user-icon {
  cursor: pointer;
}
.hostname-popover-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Dashboards/SupportDashboard/UserTable/UserTable.less"],"names":[],"mappings":"AAEA;EACC,mBAAA;EACA,aAAA;EACA,OAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AADD;AALA;EASE,aAAA;EACA,UAAA;AADF;AATA;EAaG,YAAA;EADD,uDAAuD;AACzD;AAbA;EAiBI,6BAAA;EACA,0BAAA;AADJ;AAjBA;EAuBG,4BAAA;EACA,cAAA;EACA,yBAAA;AAHH;AAtBA;EA8BE,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;AALF;AA5BA;EAoCG,cAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,WAAA;AALH;AAnCA;EA6CE,eAAA;AAPF;AAWA;EACC,aAAA;EACA,sBAAA;EACA,QAAA;AATD","sourcesContent":["@import (reference) \"../../../../Styles/colors\";\n\n.user-table-container {\n\talign-items: center;\n\tdisplay: flex;\n\tflex: 1;\n\tflex-direction: column;\n\tgap: 64px;\n\twidth: 100%;\n\n\t.search-bar {\n\t\tdisplay: flex;\n\t\twidth: 35%;\n\n\t\t.filter-select {\n\t\t\twidth: 200px;\n\n\t\t\t/* stylelint-disable-next-line selector-class-pattern */\n\t\t\t.cec-select__control {\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t\tborder-top-right-radius: 0;\n\t\t\t}\n\t\t}\n\n\t\t.filter-input {\n\t\t\tborder-bottom-left-radius: 0;\n\t\t\tborder-left: 0;\n\t\t\tborder-top-left-radius: 0;\n\t\t}\n\t}\n\n\t.user-table {\n\t\tbackground-color: white;\n\t\tborder-radius: 8px;\n\t\tpadding: 8px;\n\t\twidth: 65%;\n\n\t\t.loading-icon {\n\t\t\tcolor: @primary;\n\t\t\tdisplay: flex;\n\t\t\theight: 64.75px;\n\t\t\tjustify-content: center;\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t.edit-user-icon {\n\t\tcursor: pointer;\n\t}\n}\n\n.hostname-popover-content {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
